import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'app-client-form-section',
  templateUrl: './client-form-section.component.html',
  styleUrls: ['./client-form-section.component.scss'],
})
export class ClientFormSectionComponent implements OnInit {
  @Input() clientsFormArray: FormArray;
  @Input() canAddClient: boolean;
  @Input() canRemoveClients: boolean;
  @Input() canSetClientIdAutoIncrement: boolean;
  @Input() autoIncrementClientId: boolean;
  @Output() addClient = new EventEmitter<void>();
  @Output() removeClient = new EventEmitter<number>();
  @Output() clientIdAutoIncrementChange = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}
}
